import './index.scss'

const Experience = () => {

    return (
        <div className='experience-container'>
            <h1 className='left'>
                Student Research Assistant
            </h1>
            <h2 className='left'>
                Occidental College - Internship
            </h2>
            <h3 className='left'>
                Mar 2024 - Apr 2024
            </h3>
            <p className='left'>
            Utilized Computer Science, Data Analysis, and Data Visualization principles in order to perform Urban Environmental Policy Research.
            </p>
            <h1 className='right'>
                Data Science Intern
            </h1>
            <h2 className='right'>
                STEAM:CODERS - Internship
            </h2>
            <h3 className='right'>
                Aug 2023 - Dec 2023
            </h3>
            <p className='right'>
                Developed an ETL pipeline to consolidate, sanitize and upload data on Snowflake for analytics.
            </p>
            <h1 className='left'>
                Machine Learning Intern
            </h1>
            <h2 className='left'>
                Inspirit AI - Internship
            </h2>
            <h3 className='left'>
                Jun 2021 - Jul 2021
            </h3>
            <p className='left'>
                Developed own machine learning model to predict criminal reoffense that did not contain racial biases.
            </p>
            <h1 className='right'>
                Machine Learning Intern
            </h1>
            <h2 className='right'>
                ASDRP - Internship
            </h2>
            <h3 className='right'>
                Jun 2021 - Aug 2021
            </h3>
            <p className='right'>
                Designed and developed an ML system to identify leaves of plants that perished due to sudden oak death.
            </p>
            <h1 className='left'>
                Machine Learning Intern
            </h1>
            <h2 className='left'>
                ASDRP - Internship
            </h2>
            <h3 className='left'>
                Jun 2020 - Aug 2020
            </h3>
            <p className='left'>
            Employed supervised learning to train an ML model using several features of a player&#39;s performance to eventually predict NBA MVP player for 2023.
            </p>
        </div>
    )
}

export default Experience